import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';
import Flickity from 'flickity-fade';
import EventHandler from '@pixelunion/events';
import GalleryModal from '../components/GalleryModal';

export default class Gallery {
  constructor(section) {
    this.el = section.el;
    this.events = new EventHandler();
    this.settings = section.data;
    this.blocks = this.settings.blocks;
    this.perRow = this.settings.slides_per_row;
    this.gallery = this.el.querySelector('[data-gallery-slide]');
    this.images = document.querySelectorAll('[data-gallery-modal]');
    this.imageArray = [];
    this.modal = new GalleryModal();
    this.trigger = null;

    const toggleOptions = this.blocks > this.perRow;

    this.slideshow = new Flickity(this.gallery, {
      accessibility: false, // Flickity's inherent "accessibility" actually makes it worse
      wrapAround: true,
      pageDots: false,
      cellAlign: 'left',
      watchCSS: true,
      draggable: toggleOptions,
      prevNextButtons: toggleOptions,
      imagesLoaded: true,
    });

    this.slideshow.on('settle', () => {
      this.checkVisibility();
    });

    if (this.blocks > this.perRow === false) {
      this.toggleDraggable();

      this.events.register(window, 'resize', () => {
        this.toggleDraggable();
      });
    }

    this.events.register(this.gallery, 'rimg:load', () => {
      if (this.gallery.offsetHeight === 0) {
        this.slideshow.resize();
      }
    });

    this.initModal();
  }

  toggleDraggable() {
    if (this.viewportIsMobile()) {
      this.slideshow.options.draggable = true;
      this.slideshow.updateDraggable();
    } else {
      this.slideshow.options.draggable = false;
      this.slideshow.updateDraggable();
    }
  }

  viewportIsMobile() {
    return window.innerWidth < 768;
  }

  initModal() {
    this.images.forEach((image, selectedIndex) => {
      const { href, dataset } = image;
      const item = {
        src: href,
        w: dataset.imageWidth,
        h: dataset.imageHeight,
      };

      this.imageArray.push(item);
      this.events.register(image, 'click', e => {
        e.preventDefault();
        this.trigger = image;
        this.modal.init(this.imageArray, selectedIndex);
        trapFocus(this.modal.modalTarget);

        this.modal.modal.listen('close', () => {
          removeTrapFocus(this.modal.modalTarget);
          this.trigger.focus();
        });
      });
    });
  }

  checkVisibility() {
    const viewportX = this.slideshow.viewport.getBoundingClientRect().x;
    const viewportWidth = this.slideshow.viewport.offsetWidth;

    this.slideshow.cells.forEach(cell => {
      const cellX = cell.element.getBoundingClientRect().x - viewportX;
      const isHidden = (Math.ceil(cellX) >= viewportX && Math.ceil(cellX) >= viewportWidth);

      if (isHidden) {
        cell.element.querySelector('a').setAttribute('tabindex', -1);
        cell.element.setAttribute('aria-hidden', true);
      } else {
        cell.element.querySelector('a').setAttribute('tabindex', 0);
        cell.element.removeAttribute('aria-hidden');
      }
    });
  }

  onSectionBlockSelect(block) {
    if (this.blocks > this.perRow) {
      const { slideIndex } = block.el.dataset;
      this.slideshow.select(slideIndex);
      this.slideshow.resize();
    }
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.slideshow.destroy();
    this.modal.destroy();
  }
}
